import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { initializeIcons, LayerHost } from '@fluentui/react';
import { useAuth } from '@auth';
import apiClient from '@api/client';
import { router } from '@router';
import './App.css';

const FLUENTUI_LAYER_HOST_ID = 'fluentui-layer-host';

// Initialize Fluent UI icons
initializeIcons();

function App() {
  const { acquireToken } = useAuth();

  // Setup API client token provider (silent + interactive fallback)
  useEffect(() => {
    apiClient.setTokenProvider(async () => {
      try {
        return await acquireToken();
      } catch (error) {
        console.error('Failed to acquire token for API request:', error);
        return null;
      }
    });
  }, [acquireToken]);

  return (
    <>
      <LayerHost id={FLUENTUI_LAYER_HOST_ID} />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
